import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import InfluencerAuth from './../views/InfluencerAuth.vue'
import Account from './../views/Account.vue'
import orders from './../views/orders.vue'
import Tasks from './../views/Tasks.vue'
import SubmitFeedback from './../views/Feedback.vue'
import GettingStarted from './../views/GettingStarted.vue'
import Onboarded from './../views/Onboarded.vue'
import Internships from './../views/Internships.vue'
import Latest from './../views/Latest.vue'
import Tracker from './../views/Tracker.vue'
import DetectionViewer from './../views/DetectionViewer.vue'
import BotControl from '../views/BotControl.vue'
import Logs from '../views/Logs.vue'
import Records from '../views/Records.vue'
import AnalyseFeed from '../views/AnalyseFeed.vue'
import QueryModel from '../views/QueryModel.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    // redirect: '/latest',
    component: Home,
    name: "Robotic Battlefield Management System",
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/account',
    name: 'Profile',
    component: Account,
    meta: {
      requiresAuth: true
    }    
  },
  {
    path: '/orders',
    name: 'Orders',
    component: orders,
    meta: {
      requiresAuth: true
    }    
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: Tasks,
    meta: {
      requiresAuth: true
    }    
  },
  {
    path: '/getting-started',
    name: 'Getting Started',
    component: GettingStarted,
    meta: {
      requiresAuth: true
    }   
  },
  {
    path: '/onboarded',
    name: 'Onboarded',
    component: Onboarded,
    meta: {
      requiresAuth: true
    }   
  },
  {
    path: '/auth',
    name: "Sign In",
    component: InfluencerAuth,
    meta: {
      requiresGuest: true
    }    
  },
  {
    path: '/about',
    name: 'About',    
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/submit-feedback',
    name: 'Feedback',
    component: SubmitFeedback
  },
  {
    path: '/internships',
    name: "Internships",
    component: Internships,
    meta: {
      requiresAuth: true
    }     
  },
  {
    path: '/latest',
    name: "Latest Updates",
    component: Latest,
    meta: {
      requiresAuth: true
    }     
  },
  {
    path: '/tracking',
    name: "Tracking [Demo]",
    component: Tracker,
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/detection-viewer',
    name: "Detection Viewer",
    component: DetectionViewer,
  },
  // {
  //   path: '/logs-viewer',
  //   name: "Sentinel A3: Surveillance & Reconnaissance",
  //   component: Logs,
  // },
  {
    path: '/records',
    name: "Surveillance Records [Demo]",
    component: Records
  },
  {
    path: '/analyse-feed',
    name: "Inquisity | Interactive Planning Assistant",
    component: AnalyseFeed
  },  
  {
    path: '/query-model',
    name: "[Experimental] Query Model on Server",
    component: QueryModel
  },  
  {
    path: '/control-bot',
    name: "Sentinel: Command and Control",
    component: BotControl,
    meta: {
      requiresGuest: true
    }
  }  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
